goog.provide("shadow.js.shim.module$ol$Feature");
goog.provide("module$shadow_js_shim_module$ol$Feature");
shadow.js.shim.module$ol$Feature = shadow.js.nativeProvides["ol/Feature"] = shadow$bridge("ol/Feature");
module$shadow_js_shim_module$ol$Feature.default = shadow.js.shim.module$ol$Feature;
